import { Button, Card, Link } from "@mui/material";
import { Box } from "@mui/system";
import { AppSpec } from "../../domain/App";

interface AppItemProps {
	appSpec: AppSpec;
}

const AppItem = (props: AppItemProps) => {
	const appSpec = props.appSpec;

	return (
		<Link href={appSpec.playStore} style={{ width: 160, height: 200, textDecoration: "none" }}>
			<Card style={{ width: "100%", height: "100%", borderRadius: 8 }}>
				<Button
					style={{
						width: "100%",
						height: "100%",
						display: "flex",
						flexDirection: "column",
						justifyContent: "start",
						padding: "24px 16px",
						gap: 8,
					}}
				>
					<img
						style={{
							width: 100,
							height: 100,
							borderRadius: 16,
						}}
						src={appSpec.imgSrc}
						alt=""
					></img>
					{appSpec.name}
				</Button>
			</Card>
		</Link>
	);
};

export default AppItem;
